<div [innerHTML]="iconSvg" class="text_color_customize group-hover:text_black"></div>